<script>
import ModelEdit from '../models/edit-v2.vue';
import FormsModel from "@/components/forms/weight-note.vue";
import {serialize} from "object-to-formdata";
import Swal from 'sweetalert2';

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Nota Timbang",
  },
  props: {
    cardTitle: {
      default() {
        return "Nota Timbang"
      }
    },
    resourceRoute: {default: 'weight_notes'},
    modelVariable: {default: 'weight_note'},
    form: {
      default() {
        return FormsModel;
      }
    },
    alerts: {
      default: () => {
        return [
          {
            message: 'Pastikan jumlah fiber sudah sesuai!',
            dismissAfter: 10,
          },
        ]
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase('nota bongkar')
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('unloads.plural')),
          href: "/unload",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/unload/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/unload/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/sale_orders/${this.$route.params.key}`, {
        params: {
          with: [
            'sale_items',
            'payments',
            'ticketable',
            'files',
            'sale_items.purchase_item.purchase_order.product',
            'ticket',
            'sale_additional_items',
            'sale_items.purchase_item.purchase_order.customer'
          ].join(','),
        }
      }).then((response) => {
        const {data: {data}} = response;
        const purchase_order_ids = [...new Set(data.sale_items.filter((item) => item.purchase_item).map(v => v.purchase_item.purchase_order_id))];
        let purchase_order_id = ""
        purchase_order_ids.forEach((id) => {
          purchase_order_id += id + ","
        })
        this.model = {
          ...data,
          purchase_order_ids,
          purchase_order_id,
          actual_sale_items: data.sale_items.filter((item) => !item.purchase_item),
          files: data.files ? data.files.map((v) => {
            let file = {...v, preview: v.url, format: v.extension}
            delete file.path
            return file
          }) : [],
        };

        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    },
    update(value) {
      const val = value;
      let tripItemIds = []
      val.files = value.files.filter(v => typeof v.file !== 'string').map(v => ({...v, path: v.file}))
      delete val.sale_items;
      val.sale_items = value.trip_items.map(v => v.sale_items.map(sale_item => {
        let item = {
          ...sale_item,
          initial_quantity: v.quantity,
          initial_size: v.size,
          initial_unit_price: v.unit_price,
          trip_item_id: v.id,
          product_id: v.purchase_item.purchase_order.product_id,
        }

        if (!tripItemIds.includes(item.trip_item_id)) {
          tripItemIds.push(item.trip_item_id)
        } else {
          item.initial_quantity = 0
        }

        return item;
      })).flat()

      return this.$axios.post(`/sale_orders/${this.$route.params.key}`, (
          serialize({...val, _method: 'PUT'}, {indices: true, booleansAsIntegers: true})
      ))
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`)
    },
    deleteSuccessAlert() {
      return Swal.fire({
        title: this.$t('Deleted') + '!',
        text: this.$t(`You deleted {something} {id}`, {
          something: this.$t('unloads.plural'),
          id: this.$route.params.key
        }),
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      })
    },
    handleUpdate(value) {
      this.updating = true;
      this.update(value)
          .then((res) => this.updateSuccessAlert('dengan ID ' + res.data.data.id))
          .then(() => {
            this.isEditing = false;
            this.$router.push({path: `/unloads`});
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.updating = false;
          })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .card-form {
    .card-title:first-child {
      text-transform: uppercase !important;
    }
  }
}
</style>